import { CompletionRateStats } from './completion-rate-stats';
import { SuccessQuestionRateStat } from './success-question-rate-stat';
import { Assessment } from './assessment';
import { AttemptSuccessRate } from './attempt-success-rate';

export class Statistics {
  completionRateStats: CompletionRateStats;
  successQuestionRateStats: SuccessQuestionRateStat[];
  averageRateStat: number;
  assessment: Assessment;
  attemptSuccessRateStats: AttemptSuccessRate[];
  averageTime: number;

  constructor(
    completionRateStats: CompletionRateStats,
    successQuestionRateStats: SuccessQuestionRateStat[],
    averageRateStat: number,
    assessment: Assessment,
    attemptSuccessRateStats: AttemptSuccessRate[],
    averageTime: number
  ) {
    this.completionRateStats = completionRateStats;
    this.successQuestionRateStats = successQuestionRateStats;
    this.averageRateStat = averageRateStat;
    this.assessment = assessment;
    this.attemptSuccessRateStats = attemptSuccessRateStats;
    this.averageTime = averageTime;
  }
}
